module.exports = __webpack_public_path__ + "img/map-station-pop-bg@2x.15948c9f.png";